import { Button, Paper, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export default function NotFoundPage() {
  useTranslation();
  const navigate = useNavigate();

  return (
    <Paper>
      <Stack sx={{ gap: 3 }}>
        <Stack sx={{ gap: 1, textAlign: 'center' }}>
          <Typography variant="h5">
            <Trans i18nKey="notFound.title" />
          </Typography>
          <Typography>
            <Trans i18nKey="notFound.message" />
          </Typography>
        </Stack>
        <Stack sx={{ gap: 2, width: '100%' }}>
          <Button onClick={() => void navigate('/')}>
            <Trans i18nKey="common.actions.backToHomepage" />
          </Button>
          <Button variant="outlined" onClick={() => void navigate(-1)}>
            <Trans i18nKey="common.actions.back" />
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
